// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { TypeCampaignEnum } from '~/utils/enum/common';
import { IFormCampaign } from '~/utils/interface/campaign';

export const schema = (t: TFunction) => {
  return yup
    .object()
    .shape({
      name: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      type: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      days: yup
        .string()
        .trim()
        .required(t('common_validate_field_required', { ns: 'common/base' })),
      subject: yup
        .string()
        .trim()
        .when('type', {
          is: (value: string) => value === TypeCampaignEnum.AFTER_JOB_COMPLETES,
          then: (schema) => schema.required(t('common_validate_field_required', { ns: 'common/base' })),
          otherwise: (schema) => schema.optional(),
        }),
      content: yup
        .string()
        .trim()
        .when('type', {
          is: (value: string) => value === TypeCampaignEnum.AFTER_JOB_COMPLETES,
          then: (schema) => schema.required(t('common_validate_field_required', { ns: 'common/base' })),
          otherwise: (schema) => schema.optional(),
        }),
    })
    .required();
};

export const defaultValuesForm: IFormCampaign = {
  name: EMPTY_STRING,
  type: EMPTY_STRING,
  days: EMPTY_STRING,
  subject: EMPTY_STRING,
  content: EMPTY_STRING,
};
